<template>
  <div v-if="label" class="company-override-banner">
    <span class="company-override-banner__text">
      Aperçu&nbsp;: compagnie <strong>{{ label }}</strong> — affichage de test.
    </span>
    <a class="company-override-banner__reset" :href="resetHref">
      Revenir à Boires
    </a>
  </div>
</template>

<script>
import { mapState } from "vuex";

import { PORTAUS_COMPANY_LABELS } from "@/utils/market-utils";

export default {
  name: "CompanyOverrideBanner",
  watch: {
    // The navbar is `position: fixed; top: 0`, so the banner can only sit
    // above it by being fixed too. Flag the document so the global rules
    // below can push the navbar and the page body down by the banner height.
    label: {
      immediate: true,
      handler(value) {
        document.documentElement.classList.toggle(
          "has-company-override",
          Boolean(value)
        );
      },
    },
  },
  destroyed() {
    document.documentElement.classList.remove("has-company-override");
  },
  computed: {
    ...mapState("configuration", ["portausCompanyOverride"]),
    label() {
      const id = this.portausCompanyOverride;

      return PORTAUS_COMPANY_LABELS[id] ? `${PORTAUS_COMPANY_LABELS[id]} (${id})` : null;
    },
    // Full page load so every module re-reads the cleared override, not just
    // the components that happen to be listening.
    resetHref() {
      return `${this.$route.path}?company=0`;
    },
  },
};
</script>

<style scoped lang="scss">
.company-override-banner {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  // Above the navbar's 9999.
  z-index: 10000;
  box-sizing: border-box;
  width: 100%;
  padding: 10px 16px;
  background-color: #b58100;
  color: #fff;
  font-size: 14px;
  line-height: 1.4;
  text-align: center;

  &__reset {
    margin-left: 12px;
    color: #fff;
    font-weight: 600;
    text-decoration: underline;
  }
}
</style>

<style lang="scss">
// Unscoped on purpose: the navbar is fixed at top:0 in its own scoped block,
// so it has to be pushed down from outside when the banner is showing.
$company-override-banner-height: 38px;

// `html.` prefix so this outranks the navbar's own scoped
// `.navbar--fixed[data-v-*]` rule, which has equal specificity otherwise.
html.has-company-override {
  .navbar--fixed {
    top: $company-override-banner-height;
  }

  body {
    padding-top: $company-override-banner-height;
  }
}
</style>
